import React, { Component } from "react";
import { Router, Route, Switch } from "react-router-dom";
import Footer from "./components/Footer";
import Home from "./components/Home";
import logo from "./assets/logo.png";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import createHistory from "history/createBrowserHistory";
import Nav from "./components/Nav";
import axios from "axios";

const history = createHistory();

class App extends Component {
  constructor() {
    super();
    this.state = {
      siteInfo: "First Federal Bank",
      header: {
        0: {
          name: "<i class='fas fa-phone'></i> 1-800-369-4200",
          link: "/"
        }
      },
      barActive: false
    };
  }

  componentDidMount() {
    const SITE_URL = "https://firstfed.ggmm.io/";

    axios.get(SITE_URL + "/wp-json/acf/v3/pages?slug=contact").then(res => {
      this.setState({
        phone: res.data[0].acf.contact
      });
    });
  }

  render() {
    const { phone } = this.state;

    return (
      <Router history={history}>
        <div>
          <link
            rel="stylesheet"
            href="https://pro.fontawesome.com/releases/v5.1.0/css/all.css"
            integrity="sha384-87DrmpqHRiY8hPLIr7ByqhPIywuSsjuQAfMXAE0sMUpY3BM7nXjf+mLIUSvhDArs"
            crossOrigin="anonymous"
          />
          <Nav phone={phone} logo={logo} />

          <Route
            render={({ location }) => (
              <TransitionGroup>
                <CSSTransition
                  key={location.key}
                  timeout={300}
                  classNames="fade">
                  <Switch location={location}>
                    <Route
                      exact
                      path="/"
                      render={props => (
                        <Home
                          barActive={this.state.barActive}
                          siteTitle={this.state.siteInfo}
                          {...props}
                        />
                      )}
                    />
                  </Switch>
                </CSSTransition>
              </TransitionGroup>
            )}
          />
          <Footer title={this.state.siteInfo} />
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js